/** Must stay free of DOM, store and path-alias imports: it runs inside the detection worker. */

/** `centiles[p]` is the p-th percentile read length, p = 0…100. */
export type ReadLengthSummary = { reads: number; centiles: number[] }

/** Fewer sampled reads say too little about a length distribution to act on. */
export const MIN_LENGTH_READS = 50

export const summarizeReadLengths = (lengths: readonly number[]): ReadLengthSummary | undefined => {
  if (lengths.length < MIN_LENGTH_READS) {
    return undefined
  }
  const sorted = [...lengths].sort((a, b) => a - b)
  const centiles = Array.from({ length: 101 }, (_, p) => sorted[Math.round((p / 100) * (sorted.length - 1))])
  return { reads: sorted.length, centiles }
}

/** The distribution with every read `bases` shorter, as trimming the primers leaves it. */
export const shortenedBy = (summary: ReadLengthSummary, bases: number): ReadLengthSummary =>
  bases === 0 ? summary : { ...summary, centiles: summary.centiles.map((length) => Math.max(0, length - bases)) }

/** The share of reads outside [min, max], to the percent. */
export const shareOutside = (summary: ReadLengthSummary, min: number, max?: number): number =>
  summary.centiles.filter((length) => length < min || (max !== undefined && length > max)).length / summary.centiles.length
